// Base props for events about a contractor profile. Contractor identifiers only:
// never the contractor's or the homeowner's phone number or address.
export function profileEventProps(digitalProfile) {
  const props = {};
  const id = digitalProfile?.profileId ?? digitalProfile?.contractorId;
  if (id != null) props.contractor_profile_id = id;
  if (digitalProfile?.profileName) props.contractor_name = digitalProfile.profileName;
  return props;
}

// Survey answers as flat primitives: { survey_propertyType: "Apartment", ... }.
export function surveyEventProps(answers) {
  const props = {};
  for (const [question, answer] of Object.entries(answers || {})) {
    if (answer) props[`survey_${question}`] = answer;
  }
  return props;
}
